export default __webpack_public_path__ + "static/media/dark-wall.13fd2b6f.png";